
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class PayrollEmployeeDetailsDialog extends Serenity.EntityDialog<PayrollEmployeeDetailsRow, any> {
        protected getFormKey() { return PayrollEmployeeDetailsForm.formKey; }
        protected getIdProperty() { return PayrollEmployeeDetailsRow.idProperty; }
        protected getLocalTextPrefix() { return PayrollEmployeeDetailsRow.localTextPrefix; }
        protected getService() { return PayrollEmployeeDetailsService.baseUrl; }
        protected getDeletePermission() { return PayrollEmployeeDetailsRow.deletePermission; }
        protected getInsertPermission() { return PayrollEmployeeDetailsRow.insertPermission; }
        protected getUpdatePermission() { return PayrollEmployeeDetailsRow.updatePermission; }

        protected form = new PayrollEmployeeDetailsForm(this.idPrefix);
      
    }
}